import type { MisconceptionDefinition } from './types';

/** GELD — Geld misconcepties. */
export const GELD_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'geld.decimal-comma',
  label: 'Komma vergeten/verkeerd',
  module: 'Geld',
  description: 'Leerling plaatst de decimale komma verkeerd bij geldbedragen.',
  typicalFamilies: ['TGL-GELD-KOMMA']
}, {
  id: 'geld.change-calculation',
  label: 'Wisselgeld verkeerd berekend',
  module: 'Geld',
  description: 'Leerling berekent wisselgeld verkeerd (trekt van het verkeerde bedrag af).',
  typicalFamilies: ['TGL-GELD-TERUG', 'TGL-GELD-TERUGREKENEN']
}, {
  id: 'geld.total-vs-unit-price',
  label: 'Totaalprijs verward met eenheidsprijs',
  module: 'Geld',
  description: 'Leerling vergelijkt totaalprijzen in plaats van de prijs per eenheid (per stuk, per kg, per liter).',
  typicalFamilies: ['TGL-GELD-KOOPJES', 'TGL-GELD-PRIJS-PER']
}, {
  id: 'geld.wrong-division-direction',
  label: 'Verkeerde deelrichting bij eenheidsprijs',
  module: 'Geld',
  description: 'Leerling deelt het aantal door de prijs in plaats van de prijs door het aantal.',
  typicalFamilies: ['TGL-GELD-KOOPJES', 'TGL-GELD-PRIJS-PER']
}, {
  id: 'geld.surcharge-is-answer',
  label: 'Verwart opslag met nieuwe prijs',
  module: 'Geld',
  description: 'Leerling geeft het opslagbedrag als antwoord in plaats van de nieuwe prijs (of omgekeerd).',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.percent-equals-amount',
  label: 'Denkt dat percentage gelijk is aan bedrag',
  module: 'Geld',
  description: 'Leerling denkt dat bijv. 25% korting altijd €25 is, ongeacht het bedrag.',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.add-instead-of-subtract',
  label: 'Telt korting op in plaats van af te trekken',
  module: 'Geld',
  description: 'Leerling telt het kortingsbedrag bij de prijs op in plaats van het af te trekken.',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.confuses-discount-with-new-price',
  label: 'Verwart nieuwe prijs met kortingsbedrag',
  module: 'Geld',
  description: 'Leerling geeft de nieuwe prijs als het kortingsbedrag of omgekeerd.',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.wrong-percentage-calc',
  label: 'Berekent percentage verkeerd',
  module: 'Geld',
  description: 'Leerling maakt een rekenfout bij het berekenen van het percentage van een bedrag.',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.subtract-instead-of-add',
  label: 'Trekt opslag af in plaats van op te tellen',
  module: 'Geld',
  description: 'Leerling trekt het opslagbedrag af van de prijs in plaats van het erbij op te tellen.',
  typicalFamilies: ['TGL-GELD-KORTING']
}, {
  id: 'geld.deling-te-laag',
  label: 'Deelt te laag uit bij spaarberekening',
  module: 'Geld',
  description: 'Leerling deelt het spaardoel door een te laag getal of maakt een delingsfout waardoor het resultaat te laag is.',
  typicalFamilies: ['TGL-GELD-SPAREN']
}, {
  id: 'geld.deling-te-hoog',
  label: 'Deelt te hoog uit bij spaarberekening',
  module: 'Geld',
  description: 'Leerling deelt het spaardoel door een te hoog getal of maakt een delingsfout waardoor het resultaat te hoog is.',
  typicalFamilies: ['TGL-GELD-SPAREN']
}, {
  id: 'geld.verkeerd-deeltal',
  label: 'Gebruikt verkeerd deeltal bij sparen',
  module: 'Geld',
  description: 'Leerling deelt door het verkeerde getal (bijv. door het spaardoel i.p.v. het weekbedrag).',
  typicalFamilies: ['TGL-GELD-SPAREN']
}, {
  id: 'geld.cent-optelling-fout',
  label: 'Telt centen verkeerd op',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het optellen van centen (bijv. 50+75=100 i.p.v. 125).',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.uitgaven-als-wisselgeld',
  label: 'Verwart totale uitgaven met wisselgeld',
  module: 'Geld',
  description: 'Leerling geeft het totaal van de uitgaven als wisselgeld i.p.v. budget minus uitgaven.',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.aftrekken-vergeten',
  label: 'Maakt aftrekfout bij centen',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van centenbedragen.',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.aftrekfout-tientallen',
  label: 'Maakt aftrekfout bij tientallen',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van tientallen (bijv. 150-85=75 i.p.v. 65).',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.aftrekfout-eenheden',
  label: 'Maakt aftrekfout bij eenheden',
  module: 'Geld',
  description: 'Leerling maakt een fout bij het aftrekken van eenheden.',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.optellen-ipv-aftrekken',
  label: 'Telt op in plaats van af te trekken',
  module: 'Geld',
  description: 'Leerling telt bedragen op terwijl aftrekken gevraagd wordt (bijv. bij "hoeveel nog sparen").',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.kosten-hoger-schatten',
  label: 'Schat kosten hoger in dan ze zijn',
  module: 'Geld',
  description: 'Leerling denkt dat de kosten het budget overschrijden terwijl dat niet zo is.',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.precies-genoeg-verwarring',
  label: 'Verwart bijna genoeg met precies genoeg',
  module: 'Geld',
  description: 'Leerling denkt dat het budget precies genoeg is terwijl er geld overblijft of tekort is.',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.aftrekken-ipv-delen',
  label: 'Trekt af in plaats van te delen',
  module: 'Geld',
  description: 'Leerling trekt het weekbedrag af van het spaardoel i.p.v. te delen (bijv. €35-€5=€30 i.p.v. €35÷€5=7).',
  typicalFamilies: ['TGL-GELD-BUDGET']
}, {
  id: 'geld.percentage-van-nieuwe-prijs',
  label: 'Berekent percentage van de nieuwe prijs i.p.v. de oude',
  module: 'Geld',
  description: 'Leerling berekent het percentage van de nieuwe prijs en telt dat erbij op, in plaats van terug te rekenen naar de oude prijs.',
  typicalFamilies: ['TGL-GELD-TERUGREKENEN']
}, {
  id: 'geld.dubbele-korting',
  label: 'Past korting dubbel toe',
  module: 'Geld',
  description: 'Leerling trekt de korting er nog een keer af van de al-gereduceerde prijs.',
  typicalFamilies: ['TGL-GELD-TERUGREKENEN']
}, {
  id: 'geld.percentage-als-vast-bedrag',
  label: 'Behandelt percentage als vast bedrag',
  module: 'Geld',
  description: 'Leerling telt het percentagegetal op als vast bedrag (bijv. 20% = €20).',
  typicalFamilies: ['TGL-GELD-TERUGREKENEN']
}, {
  id: 'geld.dubbele-verhoging',
  label: 'Past verhoging dubbel toe',
  module: 'Geld',
  description: 'Leerling telt de verhoging er nog een keer bij op de al-verhoogde prijs.',
  typicalFamilies: ['TGL-GELD-TERUGREKENEN']
}, {
  id: 'geld.verkeerd-deelpercentage',
  label: 'Deelt door verkeerd percentage',
  module: 'Geld',
  description: 'Leerling deelt door het verkeerde percentage bij terugrekenen (bijv. door 0,60 i.p.v. 0,75 bij 25% korting).',
  typicalFamilies: ['TGL-GELD-TERUGREKENEN']
}];